import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { upsells } from '../data/upsells';
export function NextSteps() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-98" data-mp="30o0qg6lkb94">
      <div className="mx-auto max-w-5xl" data-id="element-99" data-mp="3u9lbahi261lb">
        <SectionHeading overline="Próximos pasos" size="lg" title={<>
              Cuando domines esta técnica,{' '}
              <span className="italic text-terracotta-500" data-id="element-101" data-mp="qqi9omnspfo3">podés ir por más</span>
            </>} subtitle="Si te enamorás de las flores prensadas, estos son los dos caminos para llevar tus creaciones a piezas todavía más especiales y vendibles." data-id="element-100" data-mp="3uamoosmjr067" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-102" data-mp="c3fdqkf4ff2v">
          {upsells.map(upsell => <article key={upsell.name} className="flex h-full flex-col overflow-hidden rounded-4xl border border-gold-200/60 bg-cream" data-id="element-103" data-mp="19ita89uz91j1">
              <div className="bg-bone px-6 py-9" data-id="element-104" data-mp="3vh1w1xce5uop">
                <img src={upsell.image} alt={`Portada de ${upsell.name}`} className="mx-auto w-full max-w-[230px] drop-shadow-[0_22px_36px_rgba(56,52,44,0.2)]" data-id="element-105" data-mp="3viczfw1xd0fa" />
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-106" data-mp="3qqd30dl2cpng">
                <h3 className="font-serif text-[1.75rem] leading-tight text-sage-800" data-id="element-107" data-mp="3qo8t9f0hgwf9">
                  {upsell.name}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-108" data-mp="3gsoywx1ki5sm">
                  {upsell.body}
                </p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-109" data-mp="32tpjmfzy3394">
                  {upsell.highlights.map(highlight => <li key={highlight} className="rounded-full bg-sage-100 px-3 py-1 text-[11.5px] font-medium text-sage-700" data-id="element-110" data-mp="37rr1ixlmwwj0">
                      {highlight}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}